import { getNewUsers } from "@/services/getNewUsers";
import { getSearchResults } from "@/services/getSearchResults";
import { INewProfiles } from "@/types/INewProfiles";
import { ISearchResults, Profile } from "@/types/ISearchResults";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ExploreState {
    profiles: Profile[];
    pageNumber: number;
    loading: boolean;
    error: string | null;
    hasMore: boolean;
    reset: boolean;
    searchString: string;
}

const initialState: ExploreState = {
    profiles: [],
    pageNumber: 0,
    loading: false,
    error: null,
    hasMore: true,
    reset: false,
    searchString: ""
};

export const fetchNewUsers = createAsyncThunk(
    "explore/fetchNewUsers",
    async (
        { pageNumber }: { pageNumber: number },
        { rejectWithValue }
    ) => {
        try {
            const data = await getNewUsers(pageNumber);
            return data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);


export const ExploreSlice = createSlice({
    name: "takes_slice",
    initialState,
    reducers: {
        resetExplore: (state) => {
            state.pageNumber = 0;
            state.profiles = [];
            state.hasMore = true;
        },
        setReset: (state, action: PayloadAction<boolean>) => {
            state.reset = action.payload;
        },
        incrementPageNumberExplore: (state) => {
            state.pageNumber += 1;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchNewUsers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchNewUsers.fulfilled, (state, action: PayloadAction<INewProfiles[]>) => {
                state.loading = false;
                const newProfiles = action.payload;
                const filteredProfiles: Profile[] = [];
                for (let i = 0; i < newProfiles.length; i++) {
                    filteredProfiles.push({
                        sr_type: 0,
                        sr_id: newProfiles[i].outId,
                        profile_id: newProfiles[i].outId,
                        profile_displayname: newProfiles[i].displayName,
                        profile_handle: newProfiles[i].handle,
                        profile_profilepic: newProfiles[i].profilePic,
                        profile_followcheck: newProfiles[i].followCheck,
                        profile_followsme: newProfiles[i].followsMe,
                        profile_isgoat: newProfiles[i].isPredictorGoat ? 1 : 0,
                        channel_name: "",
                        channel_members: "",
                        channel_picture: "",
                        channel_tags: "",
                        profile_followcount: 0
                    })
                }
                let newData = [...state.profiles, ...filteredProfiles]
                const uniqueData = newData.filter((v, i, a) => a.findIndex(t => (t.profile_id === v.profile_id)) === i)
                state.profiles = uniqueData;
                if (newProfiles.length === 0) {
                    state.hasMore = false;
                }
            })
            .addCase(fetchNewUsers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
    },
});

export const {
    incrementPageNumberExplore,
    resetExplore,
    setReset,
} = ExploreSlice.actions;

export default ExploreSlice.reducer;